import { ref } from 'vue'
import { defineStore } from 'pinia'

import type { LocationItem, ResultsLocation } from '~/core/types'

export const useSearchStore = defineStore('search', () => {
  const lastLocationResults = ref<ResultsLocation[]>([])

  const lastResultsItem = computed<LocationItem[]>(() => lastLocationResults.value.map((r) => ({
    ...r,
    fancyLabel: resultsLocationLabel(r),
  })))

  return {
    lastResultsItem,
    lastLocationResults,
  }
})
